import { useMutation } from '@tanstack/react-query';
import https from 'utils/https';
import { ENDPOINTS } from 'utils/endpoints/endpoints';
import ToastifyNotification from 'utils/toast/ToastifyNotification';

async function feedback(input) {
  const { data } = await https.post(ENDPOINTS.FEEDBACK, input);

  return data;
}

export const useFeedbackMutation = () => {
  return useMutation({
    mutationFn: input => feedback(input),
    onSuccess: data => {
      ToastifyNotification({
        message: 'Thank you. Your feedback has been received',
        errorMessage: false
      });
    },
    onError: error => {
      console.log(error);
    }
  });
};
